window.VGStore = {};

require('./sort');

$(document).ready(function () {
	$('.get-sweet-info').click(function () {
		let route = '/podarki/get-sweet-info',
			params = {
				_token: App.csrf,
				id: $(this).data('id')
			},
			$modal = $("#modal-sweet");

		$.post(route, params, function (data) {
			if (data.view) {
				$modal.find('.modal-body').html(data.view);
			}
		});
	});
});
